import { createFileRoute } from '@tanstack/react-router';

import { ApiKeysPage } from '../../pages/settings';

export const Route = createFileRoute('/_shell/settings/keys')({
  component: ApiKeysPage,
});
